import { Component, OnInit, EventEmitter, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

import { BaseComponent } from 'app/_components/base.component';
import { AuthenticationService, CompanyService, VendorService, DropdownService, VendorAvEquipmentService } from 'app/_services';
import { Vendor } from 'app/_models';
import { VendorEditFormComponent } from '../vendor-edit-form/vendor-edit-form.component';

@Component({
  selector: 'app-vendor-edit-modal',
  templateUrl: './vendor-edit-modal.component.html'
})
export class VendorEditModalComponent extends BaseComponent implements OnInit {
  @ViewChild('vendorEditForm') vendorEditForm: VendorEditFormComponent;
  public event: EventEmitter<any> = new EventEmitter();
  vendorId: number;
  vendor: Vendor;
  states: any[];
  avEquipments: any[];
  selectedAvEquipments: any[];
  constructor(
    router: Router,
    authenticationService: AuthenticationService,
    companyService: CompanyService,
    public bsModalRef: BsModalRef,
    private toastr: ToastrService,
    private vendorService: VendorService,
    private dropdownService: DropdownService,
    private vendorAvEquipmentService: VendorAvEquipmentService,
  ) {
    super(router, authenticationService, companyService);
    this.vendor = new Vendor();
    this.selectedAvEquipments = [];
  }

  public ngOnInit() {
    this.dropdownService.getDropdowns('CountryState,AvEquipment').subscribe((lists) => {
      this.states = lists.CountryState;
      this.avEquipments = lists.AvEquipment;
    });
    this.vendorService.get(this.vendorId, { company_id: this.getCurrentCompanyId() }).subscribe((vendor) => {
      this.vendor = vendor;
      if (vendor.vendor_companies && vendor.vendor_companies.length) {
        this.vendor.vendor_company_status_id = vendor.vendor_companies[0].status_id;
      }
    });
    this.vendorAvEquipmentService.list({ id: this.vendorId }).subscribe(res => {
      this.selectedAvEquipments = res.av_equipments.map(e => e.av_equipment_id);
    });
  }

  onSubmit() {
    this.vendorService.update(this.vendor, { company_id: this.getCurrentCompanyId() })
      .subscribe(vendor => {
        this.vendorAvEquipmentService.sync(this.vendorId, this.selectedAvEquipments).subscribe(() => {
          this.toastr.success('Updated!');
          this.bsModalRef.hide();
          this.event.emit(vendor);
        }, err => {
          this.toastr.error(this.getErrorMessage(err));
        });
      }, err => {
        this.toastr.error(this.getErrorMessage(err));
      });
  }
}
